import { getApplicabilityStr } from "utils";
import Card from "@/atoms/account/Card";
import { CardTitle, SecondaryTitle } from "../typography";
import Divider from "@/atoms/account/Divider";
import styled from "styled-components";
import dayjs from "dayjs";
import StyledCurrency from "./StyledCurrency";
import BookCheckoutCreditDialog from "components/bookCheckout/BookCheckoutCreditDialog";
import { Icon, IconName } from "@literati/public-ui-shared-react";

const StyledVouchers = styled(Card)`
  font-size: 13px;
`;

const StyledIconInline = styled(Icon)`
  display: inline;
  margin-bottom: 0.1rem;
  margin-left: 0.1rem;
  cursor: pointer;
`;

const Vouchers = ({ vouchers = [], totalRemainingBalance }) => {
  if (vouchers.length === 0) {
    return null;
  }

  return (
    <StyledVouchers>
      <CardTitle>Vouchers & Credit</CardTitle>
      <div>Total will be auto-applied to qualifying purchases</div>
      <Divider className={"my-4"} />
      <div className={"bg-pulp-white rounded-lg p-4 text-center"}>
        <StyledCurrency
          className={"text-textGray-darker"}
          amount={totalRemainingBalance || ""}
        />
        <div className={"text-sm font-medium text-textGray-lighter"}>
          Active credit total
        </div>
      </div>
      <div className={"grid gap-2 mt-4"}>
        <SecondaryTitle>Currently Active</SecondaryTitle>
        {vouchers.map(({ voucher, remainingBalance, id, validAfter }) => (
          <div
            key={id}
            className={
              "bg-pulp-white rounded-lg p-4 flex justify-between font-medium gap-4"
            }
          >
            <div>
              <div className={"text-textGray"}>
                {voucher.name}
                <BookCheckoutCreditDialog
                  maxPerInvoice={voucher?.maxPerInvoice}
                  label={voucher.name}
                  trigger={
                    <StyledIconInline name={IconName.INFO} fill="warmGray3" />
                  }
                />
              </div>
              <div className={"text-textGray-lighter text-xs"}>
                Usable for {getApplicabilityStr(voucher)}
              </div>
              {voucher.spendBy && (
                <div className={"text-xs mt-1 text-textGray-lighter"}>
                  Expires {dayjs(voucher.spendBy).format("M/D/YYYY")}
                </div>
              )}
              {validAfter && (
                <div className={"text-xs mt-1 text-textGray-lighter"}>
                  Valid after {dayjs(validAfter).format("M/D/YYYY")}
                </div>
              )}
            </div>
            <div className={"text-right"}>
              <div className={"text-perriwinkle font-bold whitespace-nowrap"}>
                {remainingBalance} remaining
              </div>
              <div className={"text-xs text-textGray-lighter"}>
                from {voucher.amount?.replace(/(\.0{2})/g, "")}
              </div>
            </div>
          </div>
        ))}
      </div>
    </StyledVouchers>
  );
};

export default Vouchers;
